import React from 'react';
import 'twin.macro';

import CloseQuote from './Svg/CloseQuote';
import OpenQuote from './Svg/OpenQuote';

const Quote: React.FC = ({ children, ...rest }) => (
  <div tw="flex flex-col space-y-6 text-blue my-12 max-w-3xl mx-8 lg:(mx-12) xl:(mx-16)" {...rest}>
    <OpenQuote tw="w-12 h-auto self-start" />
    <div tw="text-3xl font-semibold text-center">{children}</div>
    <CloseQuote tw="w-12 h-auto self-end" />
  </div>
);

export default Quote;
